module.exports = __webpack_public_path__ + "img/team_3.09d41ec8.png";